// extracted by css-extract-rspack-plugin
export default {"cls1":"StatelessWorkCardsUpsellModal-styles-cls1_mTY","cls2":"StatelessWorkCardsUpsellModal-styles-cls2_VMz StatelessWorkCardsUpsellModal-styles-cls1_mTY"};